import { render, staticRenderFns } from "./ShunyiPaymentRecords.vue?vue&type=template&id=3ae80742&scoped=true"
import script from "./ShunyiPaymentRecords.vue?vue&type=script&lang=js"
export * from "./ShunyiPaymentRecords.vue?vue&type=script&lang=js"
import style0 from "./ShunyiPaymentRecords.vue?vue&type=style&index=0&id=3ae80742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae80742",
  null
  
)

export default component.exports